// English translations (default)
export const en = {
  // Navigation
  nav: {
    home: "Home",
    rooms: "Rooms",
    amenities: "Amenities",
    gallery: "Gallery",
    virtualTour: "Virtual Tour",
    location: "Location",
    contact: "Contact",
    bookNow: "Book Now"
  },
  
  // Hero
  hero: {
    tagline: "Family-run 3-star hotel, 2 minutes from Velika Plaža, Ulcinj",
    description: "A simple, family-run 3-star hotel at Kepi i Gjeranave, about a 2-minute walk from the sand at the start of Velika Plaža, Ulcinj's 12 km beach. Breakfast, dinner, pool, Wi-Fi and garage parking are included. Rooms are clean and functional rather than fancy — most have a balcony, many face the sea.",
    exploreRooms: "Explore Rooms",
    viewGallery: "View Gallery",
    veryGood: "Very Good",
    reviews: "reviews",
    starHotel: "3-Star Hotel",
    bookDirect: "Book Direct & Save",
    bestPrice: "Lower than Booking.com for the same room",
    freeCancellation: "Free cancellation on flexible rates",
    noBookingFees: "No booking fees",
    checkAvailability: "Check Availability →"
  },
  
  // Booking
  booking: {
    checkAvailability: "Check Availability & Book",
    checkIn: "Check-in",
    checkOut: "Check-out",
    adults: "Adults",
    children: "Children",
    adult: "Adult",
    child: "Child",
    searchAvailability: "Search Availability",
    secureBooking: "Secure booking • Best price guarantee • Free cancellation on most rooms",
    freeCancellation: "Free cancellation on most bookings"
  },
  
  // Rooms
  rooms: {
    title: "Simple, clean rooms by the beach",
    subtitle: "Accommodations",
    description: "13 room types from a compact single to a two-bedroom apartment. Every room has air conditioning, a private bathroom and free Wi-Fi; most have a balcony. Furniture is functional, not designer.",
    viewDetails: "View Details",
    bookNow: "Book Now",
    perNight: "/night",
    guests: "Guests",
    backToRooms: "Back to All Rooms",
    roomAmenities: "Room Amenities",
    standardFeatures: "Standard Features"
  },
  
  // Room Names
  roomNames: {
    room1: "Double Room with Sea View Balcony",
    room2: "Double Room by the Pool",
    room3: "Economy Double Room with Balcony (No View)",
    room4: "Twin Room with Sea View Shared Terrace",
    room5: "Executive Triple Room with Sea View Balcony",
    room6: "Double Room with Extra Bed - Sea View Balcony",
    room7: "Two-Bedroom Family Apartment",
    room8: "Family Room with Shared Terrace",
    room9: "Family Room with Terrace",
    room10: "Small Single Room",
    room11: "Triple Room with Balcony",
    room12: "Family Room with Mountain View",
    room13: "One Bedroom Apartment"
  },
  
  // Amenities
  amenities: {
    title: "Hotel Amenities",
    subtitle: "What We Offer",
    beachfront: "Beachfront Location",
    beachfrontDesc: "Direct access to Long Beach",
    childrenPool: "Children's Pool",
    childrenPoolDesc: "Safe pool for families",
    restaurant: "Restaurant & Café",
    restaurantDesc: "Balkan cuisine · alcohol-free",
    wifi: "Free WiFi",
    wifiDesc: "High-speed internet",
    parking: "Free Parking",
    parkingDesc: "Secure parking",
    shuttle: "Airport Transfer",
    shuttleDesc: "€80 from Podgorica & Tivat (on request)",
    frontDesk: "24-Hour Front Desk",
    frontDeskDesc: "24/7 service",
    elevator: "Elevator Access",
    elevatorDesc: "All floors"
  },
  
  // Gallery
  gallery: {
    intro: "Explore the beauty of Hotel La Rosa Negra and discover the charm of Ulcinj.",
    title: "Photo Gallery",
    subtitle: "Explore Our Hotel",
    all: "All",
    rooms: "Rooms",
    pool: "Pool",
    beach: "Beach",
    restaurant: "Restaurant",
    exterior: "Exterior"
  },
  
  // Virtual Tour
  virtualTour: {
    title: "360° Virtual Tour",
    subtitle: "Experience Our Hotel",
    description: "Take a virtual walk through our beautiful hotel"
  },
  
  // Location
  location: {
    title: "Our Location",
    subtitle: "Find Us",
    address: "Address",
    nearbyAttractions: "Nearby Attractions"
  },
  
  // Contact
  contact: {
    title: "Contact Us",
    subtitle: "Get In Touch",
    name: "Name",
    email: "Email",
    message: "Message",
    send: "Send Message",
    phone: "Phone",
    whatsapp: "WhatsApp"
  },
  
  // FAQ
  faq: {
    intro: "Find answers to common questions about Hotel La Rosa Negra.",
    title: "Frequently Asked Questions",
    subtitle: "FAQ"
  },
  
  // Footer
  footer: {
    quickLinks: "Quick Links",
    contactInfo: "Contact Info",
    followUs: "Follow Us",
    rights: "All rights reserved",
    starHotel: "Star Hotel",
    description: "Experience the perfect blend of Mediterranean charm and modern comfort directly on Velika Plaža (Long Beach), Ulcinj, Montenegro.",
    rooms: "Rooms & Suites",
    amenities: "Amenities",
    gallery: "Gallery",
    location: "Location",
    reviews: "Reviews",
    legal: "Legal",
    privacy: "Privacy Policy",
    terms: "Terms & Conditions",
    cookies: "Cookie Policy",
    cancellation: "Cancellation Policy"
  },

  // Smart language-hint toast
  langHint: {
    message: "This site is also available in English",
    switch: "Switch",
    dismiss: "Dismiss"
  },
  
  // Why Book Direct
  whyBookDirect: {
    eyebrow: "Direct booking",
    heading: "Why Book Direct?",
    lead: "Booking here costs less than on Booking.com and you deal with us directly — here is exactly what you get",
    b1t: "Lower price than Booking.com",
    b1d: "Our direct rate is 10% below our Booking.com price for the same room and dates. Found it cheaper there? Send us the link and we match it.",
    b2t: "10% Discount",
    b2d: "The 10% is already in the price you see here — no code needed, no extra fees.",
    b3t: "Clear cancellation terms",
    b3d: "Flexible rates can be cancelled free of charge until the date shown in the booking step; non-refundable rates are marked as such before you pay.",
    b4t: "A person answers",
    b4d: "WhatsApp, phone or e-mail — our reception team usually replies within a few hours, 08:00–23:00.",
    cta: "Book Direct & Save"
  },

  // Amenities section headings/CTA
  amenitiesSection: {
    eyebrow: "Facilities",
    heading: "What the hotel has",
    lead: "The facilities that are actually here — nothing more, nothing less.",
    ctaTitle: "Questions before you book?",
    ctaLead: "Ask us anything about the rooms, the beach or getting here — we answer honestly.",
    ctaButton: "Contact Concierge"
  },

  // Contact section
  contactForm: {
    title: "Write to the right team",
    subtitle: "Choose a department and we will get back to you within one working day.",
    dep_sales: "Sales", hint_sales: "Group bookings, events, corporate rates, travel agencies",
    dep_jobs: "Jobs application", hint_jobs: "Send us your CV — reception, housekeeping, F&B, maintenance",
    dep_pr: "Public relations", hint_pr: "Press, media, partnerships and influencer collaborations",
    name: "Your name", email: "Email address", phone: "Phone (optional)", subject: "Subject", position: "Position you are applying for",
    message: "Your message", messageJobs: "Tell us about yourself, your experience and availability",
    attachCv: "Attach your CV (PDF or Word, max 5 MB)", send: "Send message",
    successTitle: "Message sent!", successBody: "Thank you — your message has reached our", sendAnother: "Send another message",
    error: "Could not send your message. Please try again.", privacy: "We only use your details to answer your request."
  },
  contactSection: {
    eyebrow: "Contact Us",
    heading: "Get In Touch",
    lead: "Have questions? We're here to help. Reach out to us anytime.",
    addressLabel: "Address",
    phoneLabel: "Phone",
    emailLabel: "Email",
    receptionLabel: "Reception Hours",
    reception247: "24/7 - We're always here for you",
    whatsappBtn: "Chat on WhatsApp",
    emailBtn: "Send Email",
    bookDirectTitle: "Book Direct & Save",
    bookDirectDesc: "Get 10% off when you book through our website",
    checkAvailability: "Check Availability",
    whatsappPrefill: "Hi, I would like to inquire about Hotel La Rosa Negra"
  },

  // Reviews section
  reviews: {
    eyebrow: "Guest reviews",
    heading: "What guests say — unedited",
    lead: "Reviews are copied from Booking.com as written, including the critical parts. Judge for yourself.",
    veryGood: "Very Good",
    reviewsCount: "reviews",
    starHotel: "3-Star Hotel",
    readMoreOn: "Read more reviews on",
    translatedFrom: "Translated from {lang}",
    showOriginal: "Show original",
    showTranslation: "Show translation"
  },

  // Handoff
  rate: { ask: "How was our reception today?", comment: "Optional comment…", thanks: "Thank you for your feedback!" },
  live: { replying: "You are now chatting with our reception — a person will reply here in a moment.", typing: "Reception is typing…" },
  chatContact: { ask: "Leave an e-mail or WhatsApp number so we can follow up if you have to go:", thanks: "Thank you — we will get back to you if you leave." },
  handoff: {
    prompt: "Prefer to chat with our team?",
    button: "Continue on WhatsApp",
    prefix: "Hi Hotel La Rosa Negra! I've been chatting with your website assistant and would like to continue with a person."
  },

  // Common
  common: {
    learnMore: "Learn More",
    seeAll: "See All",
    close: "Close",
    loading: "Loading..."
  }
};
